// extracted by mini-css-extract-plugin
module.exports = {"self":"Page-module--self--1UIza","image":"Page-module--image--QBfOp","text":"Page-module--text--2pE-v"};